import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { getSorting } from 'utils/general';
import {
  AdminContentReviewsFilters,
  ContentReviewDetails,
  ContentReviewListItem,
  ContentReviewStatus,
} from './admin-content-reviews.types';

interface ContentReviewsResponse {
  count: number;
  page: number;
  pageSize: number;
  data: ContentReviewListItem[];
}

interface PendingCountResponse {
  count: number;
}

const getFilters = (filters: Partial<AdminContentReviewsFilters>) => ({
  page: filters.page,
  pageSize: filters.pageSize,
  ...getSorting(filters.sort),
  search: filters.search || undefined,
  filter: {
    status: filters.status?.length ? filters.status : undefined,
    entityType: filters.entityType?.length ? filters.entityType : undefined,
    liveEntityId: filters.liveEntityId || undefined,
  },
});

interface GetContentReviews {
  filters: Partial<AdminContentReviewsFilters>;
}

interface GetContentReview {
  reviewId: string;
}

interface RejectContentReview {
  reviewId: string;
  reason?: string | null;
}

export const loaders = {
  getContentReviews: ({ filters }: GetContentReviews) => {
    return api<ContentReviewsResponse>({
      url: Endpoints.melpAdmin.contentReviews.root,
      params: getFilters(filters),
    });
  },
  getPendingCount: () => {
    return api<PendingCountResponse>({
      url: Endpoints.melpAdmin.contentReviews.pendingCount,
    });
  },
  getContentReview: ({ reviewId }: GetContentReview) => {
    return api<ContentReviewDetails>({
      url: Endpoints.melpAdmin.contentReviews.byId.replace(
        ':reviewId',
        reviewId,
      ),
    });
  },
  approveContentReview: ({ reviewId }: GetContentReview) => {
    return api<ContentReviewDetails>({
      url: Endpoints.melpAdmin.contentReviews.approve.replace(
        ':reviewId',
        reviewId,
      ),
      method: 'post',
    });
  },
  rejectContentReview: ({ reviewId, reason }: RejectContentReview) => {
    return api<ContentReviewDetails>({
      url: Endpoints.melpAdmin.contentReviews.reject.replace(
        ':reviewId',
        reviewId,
      ),
      method: 'post',
      data: { reason: reason || null },
    });
  },
};

export type { ContentReviewStatus };
